<template>
  <div style="margin: 4vh 10vw; width: 80vw; ">
    <h1 style="font-weight: bold;font-size: 30px">管理团队</h1>
    <p class="detail_page" style="margin-bottom: 0">我们特别重视企业的管理团队。SIG自身的企业文化即以激发员工的创造力，鼓励员工挑战自身极限，</p>
    <p class="detail_page">将员工成长融入企业成长而著称。因此在投资对象中，我们同样期望有创造力，理解快速发展的中国经济，兼备战略眼光和执行力的创业团队。</p>
  </div>
  <Team_post_investment_operation_bar></Team_post_investment_operation_bar>
  <router-view></router-view>
</template>

<script>
import Team_post_investment_operation_bar from "@/components/CN/team/Team_post_investment_operation_bar";

export default {
  name: 'Team_post_investment_operation',
  components: {Team_post_investment_operation_bar},
}

</script>

<style scoped>
.detail_page {
  color: black;
  white-space: pre-wrap;
  font-size: 14px;

}
</style>